// extracted by mini-css-extract-plugin
export default {"author":"Author_author__xlrkl","name":"Author_name__9Xbxc","role":"Author_role__QjpDV","big":"Author_big__c3jEK","little":"Author_little__1UBgX","modal":"Author_modal__0Y2-A"};